// @flow
import * as React from 'react';
import { CustomObservationIcon } from './CustomObservationIcon';
import './CustomObservationInfoTooltip.scss';
import {
  customObservationInfoTooltip,
  customObservationInfoTooltipText,
} from './CustomObservationInfoTooltip.scss';
import classnames from 'classnames';

export const CustomObservationInfoTooltip = () => {
  const tooltipClassname = classnames(
    customObservationInfoTooltip,
    'relative dib'
  );
  const tooltipTextClassname = classnames(
    customObservationInfoTooltipText,
    'bg-white br3 z-1 absolute o-0'
  );
  return (
    <div className={tooltipClassname}>
      <svg
        xmlns="http://www.w3.org/2000/svg"
        width="15"
        height="15"
        viewBox="0 0 24 24"
        aria-describedby="custom-observation-tooltip-text"
      >
        <path d="M0 0h24v24H0z" fill="none" />
        <path d="M12 2C6.48 2 2 6.48 2 12s4.48 10 10 10 10-4.48 10-10S17.52 2 12 2zm1 15h-2v-6h2v6zm0-8h-2V7h2v2z" />
      </svg>
      <div
        className={tooltipTextClassname}
        id="custom-observation-tooltip-text"
        role="tooltip"
      >
        <div className="gray normal f6">
          <p className="mt0 mb1">
            The observations below were flagged by the team at Power Reviews.
          </p>
          <p className="mv0 mb1">
            Observations with the <CustomObservationIcon className="v-mid" />{' '}
            icon are custom observations specific to your organization.
          </p>
        </div>
      </div>
    </div>
  );
};



// WEBPACK FOOTER //
// ./src/components/ModerationCard/CustomObservationInfoTooltip.js